<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <vs-chip
          style="cursor:pointer;"
          v-if="filtrosAplicados.length > 0"
          v-on:click.native="setFilters()"
          data-cy="setFilters"
        >
          <vs-avatar icon="search" color="primary" :badge="filtrosAplicados.length"/>
          <strong>Buscar</strong>
        </vs-chip>
        <vs-chip
          style="cursor:pointer;"
          color="gray"
          v-if="!filtrosAplicados.length"
          v-on:click.native="setFilters()"
        >
          <vs-avatar icon="search" color="#ccc"/>
          <strong
          data-cy="search-without-filters"
          >
          Buscar sin filtros aplicados
        </strong>
        </vs-chip>
        <vs-chip
          :color="colores.navbar"
          v-if="hasQueryFilters"
          style="cursor: context-menu"
          v-on:click.native="clearQueryFilters()"
        >
          <vs-avatar icon="link" color="primary"/>
          <strong>Borrar filtros de enlace</strong>
        </vs-chip>
      </div>
      <div>
        <vs-dropdown vs-trigger-click  data-cy="add-filter" >
          <vs-chip color="primary"  >
            <vs-avatar
              icon="add"
              color="primary"
            />
            Agregar filtro
          </vs-chip>
          <vs-dropdown-menu data-cy="list" class="scroll-options">
            <vs-dropdown-item
              v-for="(filter, index) in filtrosDisponibles"
              :key="`filter-${ index }`"
              v-on:click="addFilter(filter)"
              style="width:200px"
            >
              {{ filter.nombre }}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
    <div class="d-inline-block">
      <vs-chip
        color="primary" transparent
        v-for="(filtro, index) in filtrosAplicadosFiltered"
        :key="`filtro-aplicado-${ index }`"
        style="cursor: context-menu"
      >
        <vs-avatar
          data-cy="clear"
          icon="clear"
          v-on:click.native="removeFilter(filtro)"
          color="primary"
        />
        <span />
        <div
          :v-tooltip="`Modificar filtro ${filtro.nombre}`"
         @click="modificarFiltro(filtro)"
        >
          <strong>{{ filtro.nombre }}: </strong>
          <span class="pl-1">
            {{ filtro.valorFormateado }}
          </span>
        </div>
      </vs-chip>
    </div>
    <b-modal
      :title="`Filtrar por ${actualFilter.nombre}`"
      ref="configFiltro"
      @cancel="closeModal(actualFilter)"
      @close="closeModal(actualFilter)"
      no-close-on-backdrop
      centered
      hide-footer
      :hide-header-close="editMood"
    >
      <div data-cy="modal-filter" >
        <div  v-if="actualFilter.tipo === 'usuarioIds'">
          <div  class="texto-normal">
            <v-select
              :options="actualFilter.opciones"
              v-model="filterOptions.users"
              name="groups"
              multiple
            >
              <template slot="no-options">
                no hay coincidencias para el criterio de búsqueda
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'grupoIds' || actualFilter.tipo === 'loteadoraIds'">
          <div class="texto-normal">
            <v-select
              :options="actualFilter.opciones"
              v-model="filterOptions.groups"
              name="legal-qualities"
              multiple
            >
              <template slot="no-options">
                no hay coincidencias para el criterio de búsqueda
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'calidadJuridicaIds'">
          <div class="texto-normal">
            <v-select
              :options="actualFilter.opciones"
              v-model="filterOptions.legalQualities"
              name="legal-qualities"
              multiple
            >
              <template slot="no-options">
                no hay coincidencias para el criterio de búsqueda
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'gestoraIds'">
          <div class="texto-normal">
            <v-select
              :options="actualFilter.opciones"
              v-model="filterOptions.customsCompanies"
              name="custom-companies"
              multiple
            >
              <template slot="no-options">
                no hay coincidencias para el criterio de búsqueda
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'multi'">
          <div v-if="actualFilter.valor.length === 1" class="alerta">
            Debe seleccionar como mínimo 1 de las opciones. Seleccione otra
            opción antes de desmarcar la actual si es que desea cambiarla.
          </div>
          <vs-checkbox
            v-model="selectAllOptions"
            class="modal-opcion"
            v-on:change.native="selectFilter(actualFilter)"
          >
            Seleccionar Todos
          </vs-checkbox>
          <hr/>
          <br/>
          <div
            v-for="[valor, nombre] in Object.entries(actualFilter.opciones)"
            v-bind:key="nombre"
            class="modal-opcion"
          >
            <vs-checkbox
              v-model="actualFilter.valor"
              :vs-value="valor"
              v-on:change.native="selectFilter(actualFilter)"
              :disabled="actualFilter.valor.length === 1 && actualFilter.valor.includes(valor)"
            >
              {{ nombre }}
            </vs-checkbox>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'texto' || actualFilter.tipo === 'numero'">
          <div class="texto-normal">
            <tags-input
              element-id="tags"
              v-model="tags"
              add-tags-on-blur
              add-tags-on-comma
              placeholder="Agregar"
              :typeahead="true"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'fecha'">
          <div class="texto-normal">
            <date-picker
              placeholder="Seleccione una fecha"
              v-model="actualFilter.valor"
              class="w-100"
              format="DD MMM YYYY"
              value-type="YYYY-MM-DD"
              type="date"
              data-cy="filter-date"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'rangoFecha'">
          <div class="swtich-tipo-rango">
            <div class="rango-parte">Rango Simple</div>
            <div class="rango-parte rango-switch">
              <vs-switch v-model="tipoRangoFechaAvanzado"/>
            </div>
            <div class="rango-parte">Rango Avanzado</div>
          </div>
          <br/>
          <hr/>
          <br/>
          <div v-if="!tipoRangoFechaAvanzado">
            <div class="center">
              <template
                v-for="(periodo, index) in periodos"
              >
                <vs-button
                  :disabled="periodo.valor === actualFilter.valor"
                  size="medium" color="primary" type="filled"
                  v-on:click="seleccionarRango(periodo.valor)"
                  class="w-full mb-1"
                  :key="`periodo-${index}`"
                >
                  {{ periodo.nombre.charAt(0).toUpperCase() + periodo.nombre.slice(1) }} <br/>
                  <span style="font-size: 80%">
                  (desde el {{ formatoTipoRango(periodo.valor, true) }} hasta hoy)
                </span>
                </vs-button>
              </template>
            </div>
          </div>
          <div v-if="tipoRangoFechaAvanzado">
            entre el
            <datetime
              v-model="rangoAvanzado.desde"
              input-class="input-date"
              :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local" format="yyyy-MM-dd"
            />
            y el
            <datetime
              v-model="rangoAvanzado.hasta"
              input-class="input-date" :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local"
              format="yyyy-MM-dd"
            />
          </div>
        </div>
      </div>
      <div class="text-center mt-2">
        <vs-button size="small" v-on:click="verificarFiltrosAlCerrar" >
          Confirmar
        </vs-button>
      </div>
    </b-modal>
  </div>
</template>
<script>

import { mapGetters, mapState } from 'vuex';
import Vue from 'vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
  name: 'FiltersAduanas',
  props: {
    filtersView: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: false
    },
    customsCompanies: {
      type: Array,
      required: false
    },
    groups: {
      type: Array,
      required: false
    },
    legalQualities: {
      type: Array,
      required: false
    },
    periodos: {
      type: Array,
      required: false
    },
    hasQueryFilters: {
      type: Boolean,
      default: false
    },
    clearQueryFilters: {
      type: Function
    }
  },
  components: { DatePicker },
  data() {
    return {
      editMood: false,
      modalFilter: false,
      actualFilter: {},
      filtrosAplicados: [],
      filtrosDisponibles: [],
      selectAllOptions: false,
      tipoRangoFechaAvanzado: false,
      tipoRango: false,
      fechaSimpleActual: '',
      rangoAvanzado: {
        desde: '',
        hasta: ''
      },
      tag: '',
      tags: [],
      filterOptions: {
        users: [],
        groups: [],
        legalQualities: [],
        customsCompanies: []
      }
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'actualFilter.valor': function (nuevoValor) {
      if (this.actualFilter.tipo === 'fecha') {
        this.actualFilter.valor = Vue.moment(nuevoValor).format('YYYY-MM-DD');
        this.actualFilter.valorFormateado = Vue.moment(nuevoValor).format('YYYY-MM-DD');
      }
    },
    // eslint-disable-next-line func-names
    'actualFilter.valorFormateado': function (nuevoValor) {
      this.actualFilter.valorFormateado = nuevoValor;
    },
    // eslint-disable-next-line func-names
    'filterOptions.users': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((user) => user.value);
      this.actualFilter.valorFormateado = valorNuevo.map((user) => user.label).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.legalQualities': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((option) => option.value);
      this.actualFilter.valorFormateado = valorNuevo.map((option) => option.label).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.customsCompanies': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((option) => option.value);
      this.actualFilter.valorFormateado = valorNuevo.map((option) => option.label).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.groups': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((option) => option.value);
      this.actualFilter.valorFormateado = valorNuevo.map((option) => option.label).join(',');
    },
    rangoAvanzado: {
      handler(valor) {
        this.$log.debug('watch.rangoAvanzado');
        this.$log.info('valor rango avanzado', valor);
        try {
          const desde = valor.desde.split('T')[0];
          const hasta = valor.hasta.split('T')[0];
          this.actualFilter.valor = `${desde}--${hasta}`;
        } catch (e) {
          this.$log.info('Una de las fechas de rango avanzado no esta correctamente '
            + 'formateada,se necesitan ambas para setear el valor del filtro');
        }
        this.seleccionarRango(this.actualFilter.valor);
      },
      deep: true
    },
    tipoRangoFechaAvanzado() {
      if (!this.actualFilter.valor.includes('--') && !this.actualFilter.valor.includes(' ')) {
        this.rangoAvanzado.desde = this.formatoTipoRango(this.actualFilter.valor);
        this.rangoAvanzado.hasta = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
        this.actualFilter.valor = `${this.rangoAvanzado.desde }--${ this.rangoAvanzado.hasta}`;
        // this.seleccionarRango(this.actualFilter.valor);
      } else {
        const [desde, hasta] = this.actualFilter.valor.split('--');
        this.rangoAvanzado.desde = desde;
        this.rangoAvanzado.hasta = hasta;
      }
    },
    tags(valorNuevo) {
      const valor = valorNuevo;

      this.actualFilter.valor = valor.map((tag) => tag.value); // .join(",");
      this.actualFilter.valorFormateado = valor.map((tag) => tag.value).join(', ');

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: valor.map((tag) => tag.value).join(','),
            valorFormateado: valor.map((tag) => tag.value).join(', ')
          };
        }
        return filterApplied;
      });
    },
    selectAllOptions(valorNuevo) {
      if (valorNuevo === true) {
        if (this.actualFilter.valor.length !== Object.keys(this.actualFilter.opciones).length) {
          this.actualFilter.valor = Object.keys(this.actualFilter.opciones);
          this.actualFilter.valorFormateado = Object.values(this.actualFilter.opciones);
        }
      } else {
        this.actualFilter.valor = [];
        this.actualFilter.valorFormateado = [];
      }
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapState('Personalizacion', {
      colores: (state) => state.colores
    }),
    filtrosAplicadosFiltered() {
      return this.filtrosAplicados.filter((filtro) => filtro.valor !== '');
    }
  },
  methods: {
    clearOptions() {
      this.tag = '';
      this.tags = [];
    },
    removeFilter(filter) {
      this.filtrosAplicados = this.filtrosAplicados
        .filter((filterApplied) => filterApplied.campo !== filter.campo);
      switch (filter.tipo) {
        case 'multi': {
          this.selectAllOptions = false;
          break;
        }
        case 'usuarioIds': {
          this.filterOptions.users = [];
          break;
        }
        case 'loteadoraIds': {
          this.filterOptions.groups = [];
          break;
        }
        case 'calidadJuridicaIds': {
          this.filterOptions.legalQualities = [];
          break;
        }
        case 'gestoraIds': {
          this.filterOptions.customsCompanies = [];
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
    },
    formatoTipoRango(formato, humano = false) {
      const estilo = humano ? 'LL' : 'YYYY-MM-DD';
      switch (formato) {
        case 'ultimas4semanas':
          return Vue.moment().subtract(28, 'days').format(estilo);
        case 'esteMes':
          return Vue.moment().startOf('month').format(estilo);
        case 'esteMesConAnterior':
          return Vue.moment().subtract(1, 'month').startOf('month').format(estilo);
        case 'ultimos3meses':
          return Vue.moment().subtract(2, 'month').startOf('month').format(estilo);
        case 'ultimos6meses':
          return Vue.moment().subtract(5, 'month').startOf('month').format(estilo);
        default:
          return Vue.moment().subtract(5, 'month').startOf('month').format(estilo);
      }
    },
    formatRangeDate() {
      if (this.actualFilter.valor.includes('--')) {
        const [desde, hasta] = this.actualFilter.valor.split('--');
        this.actualFilter.valorFormateado = `${desde} al ${hasta}`;
      } else {
        const foundPeriod = this.periodosDisponibles
          .find((period) => period.valor === this.actualFilter.valor);
        this.actualFilter.valorFormateado = foundPeriod.nombre;
      }
    },
    seleccionarRango(valor) {
      if (valor === 'personalizado') {
        this.tipoRangoFechaAvanzado = true;
        this.actualFilter.valor = valor;
      } else {
        this.actualFilter.valor = valor;
        this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
          if (filterApplied.campo === this.actualFilter.campo) {
            return {
              ...filterApplied,
              valor,
              valorFormateado: this.formatRangeDate()
            };
          }
          return filterApplied;
        });
      }
    },
    modificarFiltro(filter) {
      // this.clearOptions();
      this.editMood = true;
      this.actualFilter = filter;
      if (this.actualFilter.tipo === 'rangoFecha') {
        if (this.actualFilter.valor.includes('--')) {
          this.tipoRangoFechaAvanzado = true;
          const [desde, hasta] = filter.valor.split('--');
          this.rangoAvanzado.desde = desde;
          this.rangoAvanzado.hasta = hasta;
        } else {
          this.tipoRangoFechaAvanzado = false;
        }
      } else if (this.actualFilter.tipo === 'numero' || this.actualFilter.tipo === 'texto') {
        this.tags = this.actualFilter.valor.map((valor) => ({ value: valor }));
        this.tipoRango = this.actualFilter.valor.includes('--');
      }

      this.actualFilter.valor = filter.valor;
      this.$refs.configFiltro.show();
    },
    seleccionarTodos() {
      this.actualFilter.valor = Object.keys(this.actualFilter.opciones);
    },
    closeModal(filter) {
      this.removeFilter(filter);
      this.editMood = false;
    },
    verificarFiltrosAlCerrar() {
      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: this.actualFilter.valor,
            valorFormateado: this.actualFilter.valorFormateado
          };
        }
        return filterApplied;
      }).filter((filter) => filter.valor.length > 0 && filter.valor !== '');

      // this.actualFilter = {};
      this.$refs.configFiltro.hide();
      this.editMood = false;
    },
    setFilters(onMounted = false) {
      const query = [];
      // para los filtros
      this.filtersView.filtrosFijos.forEach((filter) => {
        let { valor } = filter;
        // eslint-disable-next-line no-template-curly-in-string
        if (valor === '${iutEmpresa}') {
          // eslint-disable-next-line no-template-curly-in-string
          valor = valor.replace('${iutEmpresa}', this.company.iut);
        }
        // eslint-disable-next-line no-template-curly-in-string
        if (valor === '${correoUsuario}') {
          // eslint-disable-next-line no-template-curly-in-string
          valor = valor.replace('${correoUsuario}', this.currentUser.correo);
        }
        // eslint-disable-next-line no-template-curly-in-string
        if (valor === '${idUsuario}') {
          // eslint-disable-next-line no-template-curly-in-string
          valor = valor.replace('${idUsuario}', this.currentUser.id);
          valor = valor.concat(',--grupos--');
        }
        if (filter.tipo === 'multi') {
          valor = Object.keys(filter.opciones);
        }
        query.push(`${ filter.campo }:${ valor}`);
      });

      // para los filtros disponibles que fueron aplicados

      this.filtrosAplicados.forEach((filter) => {
        if (filter.tipo === 'rangoFecha' && !filter.valor.includes('--')) {
          const inicio = this.formatoTipoRango(filter.valor);
          const fin = Vue.moment().format('YYYY-MM-DD');
          query.push(`${filter.campo}:${inicio}--${fin}`);
        } else if (filter.valor.length > 0 && filter.valor !== '') {
          query.push(`${ filter.campo }:${ filter.valor }`);
        }
      });

      this.$emit('filtros-aplicados', query.join('|'), onMounted);
    },
    searchAvailableFilters() {
      let { filtrosHabilitados } = this.filtersView;

      filtrosHabilitados = filtrosHabilitados
        .sort(({ nombre: a }, { nombre: b }) => a.localeCompare(b));
      this.filtrosDisponibles = { ...filtrosHabilitados };
    },
    setOptionsFilter(addedFilter) {
      let opciones = [];
      switch (addedFilter.tipo) {
        case 'usuarioIds': {
          opciones = this.users.map((user) => {
            const userOption = {
              label: user.nombre,
              value: user.id
            };
            return userOption;
          });
          break;
        }
        case 'calidadJuridicaIds': {
          opciones = this.legalQualities.map((option) => {
            const groupOption = {
              label: option.label,
              value: option.value
            };
            return groupOption;
          });
          break;
        }
        case 'gestoraIds': {
          opciones = this.customsCompanies;
          break;
        }
        case 'loteadoraIds': {
          opciones = this.groups.map((group) => {
            const groupOption = {
              label: group.nombre,
              value: group.id
            };
            return groupOption;
          });
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
      return opciones;
    },
    addFilter(filter) {
      this.actualFilter = {};
      this.clearOptions();

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === filter.campo) {
          return {
            ...filterApplied,
            valor: filter.valor,
            valorFormateado: filter.valorFormateado
          };
        }
        return filterApplied;
      }).filter((filter2) => filter2.valor.length > 0 && filter2.valor !== '');

      const isApplied = this.filtrosAplicados
        .some((filterApplied) => filterApplied.campo === filter.campo);

      if (isApplied) {
        return;
      }

      this.actualFilter = filter;
      const addedFilter = filter;
      switch (addedFilter.tipo) {
        case 'usuarioIds': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'loteadoraIds': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'calidadJuridicaIds': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'gestoraIds': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'multi': {
          this.selectAllOptions = false;
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
      this.filtrosAplicados.push(addedFilter);
      this.$refs.configFiltro.show();
    },
    selectFilter(filter) {
      this.actualFilter.valorFormateado = filter.valor
        .map((valor) => this.actualFilter.opciones[valor])
        .join(', ');

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === filter.campo) {
          return {
            ...filterApplied,
            valorFormateado: this.actualFilter.valorFormateado,
            valor: filter.valor
          };
        }
        return filterApplied;
      });
      if (this.actualFilter.valor.length === Object.keys(this.actualFilter.opciones).length) {
        this.selectAllOptions = true;
      }
    }
  },
  mounted() {
    this.searchAvailableFilters();
    this.setFilters(true);
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}

.scroll-options {
  max-height: 400px;
  overflow-y: scroll;
}
</style>

<style>
.mx-input {
  padding: 20px 10px 20px 35px;
  color: #6e6b7b;
}
.mx-icon-calendar {
  left: 10px
}
</style>
